// extracted by mini-css-extract-plugin
export default {"container":"email-confirmation_container__SSHzS","subcontainer":"email-confirmation_subcontainer__jWw+u"};